<template>
  <div class="modal" id="Modal" tabindex="-1" role="dialog" aria-labelledby="exampleModalLabel" aria-hidden="true">
      <div id="ModalContent" class="modal__content modal__content--md" v-if="email">
        <div class="flex items-center px-5 py-5 sm:py-3 border-b border-gray-200">
          <h2 class="font-medium text-base mr-auto">
              {{email.name}} <app-title-custom />
          </h2>
          <button type="button" class="close" @click="$emit('closeModal')">
            <span aria-hidden="true">×</span>
          </button>
        </div>
        <div class="intro-y box py-5">
          <div class="wizard flex flex-col px-5">
            <div class="bg-gray-200 p-2 rounded-md">
              <p class="mb-2">
                {{email.campaign_attribute.project_name}} -
                {{email.campaign_attribute.project_account_name}} -
                {{email.campaign_attribute.project_account_country_prefix}} -
                {{email.campaign_attribute.name}}
              </p>
              <p class="mb-2" v-if="email.hours">
                <b>HORAS:</b> {{email.hours}}
              </p>
              <p class="mb-2">
                <b>Creada el día:</b> {{email.created_at}}
                <b>por</b> {{email.user_created_name}}
                <a v-if="email.path" class="text-blue-500" :href="email.path" target="_blank">Ver archivo aquí</a>
              </p>
              <p class="mb-2">
                La tarea fue realizada por <b>{{email.user_name}}</b>
              </p>
              <hr class="my-3">
              <p class="mb-2"><b>Respuesta</b></p>
              <p class="mb-2">
                {{email.response_observations}} <br>
                <b>{{email.date}}</b>
                <a v-if="email.response_path"
                  class="text-blue-500"
                  :href="email.response_path"
                  target="_blank">
                  Ver archivo aquí
                </a>
              </p>
            </div>
            <hr class="my-3">
            <p class="mb-2"><b>Versiones</b></p>
            <div class="bg-gray-100 rounded-md mb-2 p-2" v-for="version in versions" v-if="version.email_id == email.id">
              {{version.observations}} <br>
              {{version.created_at}}
              <a v-if="version.path" class="text-blue-500" :href="version.path" target="_blank">Ver archivo aquí</a>
              <br>
              <b>Respuesta</b> <br>
              {{version.response_observations}} <br>
              {{version.updated_at}}
              <a v-if="version.response_path" class="text-blue-500" :href="version.response_path" target="_blank">Ver archivo aquí</a>
              <hr>
            </div>
          </div>
        </div>
      </div>
      <app-loading v-else />
  </div>
</template>

<script>
  import Loading from '@/components/admin/partials/LoadingWhite'
  import TitleCustom from '@/components/admin/partials/TitleCustom'

	export default {
    name: 'ViewEmailModal',
    props: ['email','versions'],
    data() {
      return {
        errors: [],
      }
    },
    async beforeMount () {
      document.body.className = 'overflow-hidden';
    },
    beforeDestroy() {
      document.body.classList.remove('overflow-hidden');
    },
    components: {
      appLoading: Loading,
      appTitleCustom: TitleCustom,
    }
	}
</script>

<style>
#Modal {
  visibility: initial;
  opacity: unset;
  z-index: 100000000000;
  margin: unset;
  display: flex
}

#ModalContent {
  margin-top: auto;
  margin-bottom: auto
}
</style>



// WEBPACK FOOTER //
// ViewEmailModal.vue?50bc2994